import React from "react";
import {useContext} from "../contexts/Context";
import {Navigate, Outlet, useLocation} from "react-router-dom";
import LoadingSpinner from "../components/common/LoadingSpinner";

const AdminRouteGuard = () => {
    const {isAdminExists, isAdminLoading} = useContext()
    const location = useLocation();

    if (isAdminLoading) {
        return <LoadingSpinner/>;
    }

    return isAdminExists ? (
        <Navigate to="/login" replace state={{from: location}}/>
    ) : (
        <Outlet />
    );
};

export default AdminRouteGuard;
